module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h1', [_vm._v("Vue 组件 DEMO")]), _vm._v(" "), _c('img', {
    attrs: {
      "height": "600",
      "src": "http://upload-images.jianshu.io/upload_images/2250086-abb5985cb7931e9b.jpg?imageMogr2/auto-orient/strip%7CimageView2/2/w/1240",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-016f34a6"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 102
// module chunks = 1